import { defineStyleConfig } from "@chakra-ui/react";

/**
 * Container component configuration with max-width of 45ch.
 */
export const APP_MAX_WIDTH = "45ch";

export const Container = defineStyleConfig({
  baseStyle: {
    maxW: APP_MAX_WIDTH,
  },
});
